import { ComponentProps, PropsWithChildren } from 'react';

import { Text } from '../Text';

export const ArticleTitle = ({
  className,
  children,
  color = 'black',
  fontSize = 12,
  lineHeight = '140%',
  fontWeight = 600,
  dangerouslySetInnerHTML,
  ...props
}: PropsWithChildren<ComponentProps<typeof Text>>) => {
  return (
    <Text
      className={className}
      color={color}
      fontSize={fontSize}
      fontWeight={fontWeight}
      lineHeight={lineHeight}
      dangerouslySetInnerHTML={dangerouslySetInnerHTML}
      variant="primary"
      {...props}
    >
      {children}
    </Text>
  );
};

export const ArticleDescription = ({
  className,
  children,
  color = 'neutral-4-100',
  fontSize = 12,
  lineHeight = '160%',
  fontWeight = 400,
  dangerouslySetInnerHTML,
  fontFamily,
  ...props
}: PropsWithChildren<ComponentProps<typeof Text>>) => {
  return (
    <Text
      className={className}
      color={color}
      fontSize={fontSize}
      fontWeight={fontWeight}
      lineHeight={lineHeight}
      fontFamily={fontFamily || 'var(--font-merriweather-mono)'}
      dangerouslySetInnerHTML={dangerouslySetInnerHTML}
      variant="secondary"
      {...props}
    >
      {children}
    </Text>
  );
};

export const ArticleDate = ({
  className,
  children,
  color = 'neutral-4-70',
  fontSize = 12,
  lineHeight = '100%',
  fontWeight = 500,
}: PropsWithChildren<ComponentProps<typeof Text>>) => {
  return (
    <Text
      className={className}
      color={color}
      fontSize={fontSize}
      fontWeight={fontWeight}
      lineHeight={lineHeight}
    >
      {children}
    </Text>
  );
};
